import { usePopup } from '@contexts/popupContext';
import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/components/Components.module.css';
import { useState } from 'react';
import ResultPopup from '@components/General/ResultPopup';
import { TextInput } from './TextInput';

interface TextEntryPopupProps {
    title: string;
    message: string;
    placeholder: string;
    onConfirmClick: (string) => Promise<void>;
    onCancelClick?: () => Promise<void>;
    onSuccess?: () => void;
    successMessage: string;
    cancelMessage: string;
    errorMessage: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const TextEntryPopup = ({
	title,
	message,
    placeholder,
	onConfirmClick,
    onCancelClick,
	onSuccess,
	successMessage,
    cancelMessage,
	errorMessage,
	confirmButtonText = 'Aceptar'.localized(),
	cancelButtonText = 'Cancelar'.localized(),
}: TextEntryPopupProps) => {
	const { hidePopup, showPopup } = usePopup();
	const [loading, setLoading] = useState(false);
    const [enteredText, setValue] = useState('');
    const [error, setError] = useState('');

	const handleConfirmation = async () => {
		setLoading(true);
		try {
			await onConfirmClick(enteredText);
			showPopup(() => <ResultPopup result={successMessage} succesful={true} />);
			onSuccess?.();
		} catch (error) {
			showPopup(() => <ResultPopup result={errorMessage} succesful={false} />);
			console.error(error);
		}
		setLoading(false);
	};

    const handleCancel = async () => {
        if (!onCancelClick) {
            hidePopup();
            return;
        }

		setLoading(true);
		try {
			await onCancelClick();
			showPopup(() => <ResultPopup result={cancelMessage} succesful={true} />);
			onSuccess?.();
		} catch (error) {
			showPopup(() => <ResultPopup result={errorMessage} succesful={false} />);
			console.error(error);
		}
		setLoading(false);
    }

	return (
		<div className={styles['popup-with-text']}>
			<div className={styles['title']}>{title}</div>
            <div className={styles['main-container']}>
                <TextInput
                    label={message}
                    placeholder={placeholder}
                    type="text"
                    value={enteredText}
                    onChange={setValue}
                    error={error}
                />
            </div>
			<div className={styles['bottom-container']}>
				<div className={`${styles['button']} ${styles['cancel-action']}`} onClick={handleCancel}>
					{cancelButtonText}
				</div>

				<div
					className={`${styles['button']} ${styles['main-action']}`}
					onClick={handleConfirmation}>
					{!loading ? (
						confirmButtonText
					) : (
						<div className={styles['loading-container']}>
							<Loader height="32px" width="32px" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TextEntryPopup;
